"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SSRDataTkn = exports.SSRDataObjects = exports.SSRDataJson = exports.SSRData = exports.SPLIT_INTO_THREE = exports.SPLIT_INTO_FOUR = exports.SOURCE_KEYS = exports.SHOPPING_PLATFORM = exports.REVERSE = exports.INSER_ONLY_AT_3_WITH_3_CHAR = exports.INSERT_RANDOM_AT_3 = exports.INSERT_ONLY_AT_3 = exports.ChannelDetails = exports.BEARER = exports.BASE64 = exports.ApiData = exports.AlgoSynonyms = exports.ALGORITHM_INDEX = exports.ALGORITHMS = exports.ADD_EXTRA_CHAR = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
/* eslint-disable lines-between-class-members */

/* eslint-disable camelcase */

/* eslint-disable max-classes-per-file */


var SSRDataTkn = function SSRDataTkn() {
  (0, _classCallCheck2.default)(this, SSRDataTkn);
  (0, _defineProperty2.default)(this, "addons", '');
  (0, _defineProperty2.default)(this, "seat", '');
  (0, _defineProperty2.default)(this, "checkout", '');
  (0, _defineProperty2.default)(this, "search", '');
  (0, _defineProperty2.default)(this, "available_dates", '');
  (0, _defineProperty2.default)(this, "hotel", '');
};

exports.SSRDataTkn = SSRDataTkn;

var SSRData = function SSRData() {
  (0, _classCallCheck2.default)(this, SSRData);
  (0, _defineProperty2.default)(this, "ssr_data", []);
} // it will cotain SSRDataObjects
;

exports.SSRData = SSRData;

var SSRDataObjects = function SSRDataObjects() {
  (0, _classCallCheck2.default)(this, SSRDataObjects);
  (0, _defineProperty2.default)(this, "source", void 0);
  (0, _defineProperty2.default)(this, "ssrlist", void 0);
  (0, _defineProperty2.default)(this, "ssrgroup", void 0);
};

exports.SSRDataObjects = SSRDataObjects;

var SSRDataJson = function SSRDataJson() {
  (0, _classCallCheck2.default)(this, SSRDataJson);
  (0, _defineProperty2.default)(this, "synonyms", []);
  (0, _defineProperty2.default)(this, "api_data", []);
} // will contain api data
;

exports.SSRDataJson = SSRDataJson;

var AlgoSynonyms = function AlgoSynonyms() {
  (0, _classCallCheck2.default)(this, AlgoSynonyms);
  (0, _defineProperty2.default)(this, "name", '');
  (0, _defineProperty2.default)(this, "value", []);
} // string[]
;

exports.AlgoSynonyms = AlgoSynonyms;

var ApiData = function ApiData() {
  (0, _classCallCheck2.default)(this, ApiData);
  (0, _defineProperty2.default)(this, "source", '');
  (0, _defineProperty2.default)(this, "id", '');
};

exports.ApiData = ApiData;
var BEARER = 'Bearer ';
exports.BEARER = BEARER;
var ALGORITHMS = {
  ALGO_ONE: ['BASE64', 'SPLIT_INTO_FOUR', 'REVERSE'],
  ALGO_TWO: ['BASE64', 'SPLIT_INTO_THREE', 'ADD_EXTRA_CHAR'],
  ALGO_THREE: ['BASE64', 'SPLIT_INTO_FOUR', 'REVERSE', 'INSERT_RANDOM_AT_3'],
  ALGO_FOUR: ['BASE64', 'SPLIT_INTO_FOUR', 'REVERSE', 'INSERT_ONLY_AT_3'],
  ALGO_FIVE: ['BASE64', 'SPLIT_INTO_THREE', 'INSER_ONLY_AT_3_WITH_3_CHAR', 'ADD_EXTRA_CHAR']
};
exports.ALGORITHMS = ALGORITHMS;
var BASE64 = 'BASE64';
exports.BASE64 = BASE64;
var REVERSE = 'REVERSE';
exports.REVERSE = REVERSE;
var ADD_EXTRA_CHAR = 'ADD_EXTRA_CHAR';
exports.ADD_EXTRA_CHAR = ADD_EXTRA_CHAR;
var SPLIT_INTO_THREE = 'SPLIT_INTO_THREE';
exports.SPLIT_INTO_THREE = SPLIT_INTO_THREE;
var SPLIT_INTO_FOUR = 'SPLIT_INTO_FOUR';
exports.SPLIT_INTO_FOUR = SPLIT_INTO_FOUR;
var INSERT_RANDOM_AT_3 = 'INSERT_RANDOM_AT_3';
exports.INSERT_RANDOM_AT_3 = INSERT_RANDOM_AT_3;
var INSERT_ONLY_AT_3 = 'INSERT_ONLY_AT_3';
exports.INSERT_ONLY_AT_3 = INSERT_ONLY_AT_3;
var INSER_ONLY_AT_3_WITH_3_CHAR = 'INSER_ONLY_AT_3_WITH_3_CHAR';
exports.INSER_ONLY_AT_3_WITH_3_CHAR = INSER_ONLY_AT_3_WITH_3_CHAR;
var SOURCE_KEYS = {
  ADD_ONS_KEY: 'addons',
  SEAT_KEY: 'seat',
  CHECKOUT_KEY: 'checkout',
  SEARCH_KEY: 'search',
  AVAILABLE_DATES_KEY: 'available_dates',
  HOTEL_KEY: 'hotel'
};
exports.SOURCE_KEYS = SOURCE_KEYS;
var SHOPPING_PLATFORM = 'Shopping Website ';
exports.SHOPPING_PLATFORM = SHOPPING_PLATFORM;
var ALGORITHM_INDEX = 3;
exports.ALGORITHM_INDEX = ALGORITHM_INDEX;

var ChannelDetails = function ChannelDetails(Channel, ChannelHash, ChannelId, Platform, ProductId) {
  (0, _classCallCheck2.default)(this, ChannelDetails);
  (0, _defineProperty2.default)(this, "Channel", void 0);
  (0, _defineProperty2.default)(this, "ChannelHash", void 0);
  (0, _defineProperty2.default)(this, "ChannelId", void 0);
  (0, _defineProperty2.default)(this, "Platform", void 0);
  (0, _defineProperty2.default)(this, "ProductId", void 0);
  this.Channel = Channel;
  this.ChannelHash = ChannelHash;
  this.ChannelId = ChannelId;
  this.Platform = Platform;
  this.ProductId = ProductId;
};

exports.ChannelDetails = ChannelDetails;